module.exports = __webpack_public_path__ + "img/logo@3x.02118fd5.png";